module.exports = __webpack_public_path__ + "static/media/close.f55f6d9d.svg";